import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "input-group input-group-sm" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "input-group-append" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "card-tools" }
const _hoisted_20 = ["title"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-redo",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["title"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "card-body table-body" }
const _hoisted_27 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_28 = { class: "btn-group" }
const _hoisted_29 = ["onClick", "title"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick", "title"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick", "title"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx, _cache) {
  const _component_table_lite = _resolveComponent("table-lite")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.termsUse")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.termsUse")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filter) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys((...args) => (_ctx.doFilter && _ctx.doFilter(...args)), ["enter"])),
                  type: "text",
                  class: "form-control",
                  placeholder: _ctx.$t('labels.search')
                }, null, 40, _hoisted_15), [
                  [_vModelText, _ctx.filter]
                ]),
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info btn-flat",
                    onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.doFilter && _ctx.doFilter(...args)))
                  }, _hoisted_18)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-sm btn-default btn-new",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.reload())),
                style: {"width":"33px"},
                title: _ctx.$t('labels.buttons.reload')
              }, _hoisted_22, 8, _hoisted_20),
              _createTextVNode("   "),
              (_ctx.hasPermission('create'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "newButton",
                    class: "btn btn-sm btn-primary btn-new",
                    onClick: _cache[4] || (_cache[4] = $event => (_ctx.newRow())),
                    style: {"width":"33px"},
                    title: _ctx.$t('labels.buttons.new')
                  }, _hoisted_25, 8, _hoisted_23))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_table_lite, {
              "is-slot-mode": true,
              "is-loading": _ctx.table.isLoading,
              columns: _ctx.table.columns,
              rows: _ctx.table.rows,
              total: _ctx.table.totalRecordCount,
              sortable: _ctx.table.sortable,
              messages: _ctx.table.messages,
              onDoSearch: _ctx.doSearch,
              onIsFinished: _cache[5] || (_cache[5] = $event => (_ctx.table.isLoading = false))
            }, {
              enabled: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.enabled,
              'bg-danger': !props.value.enabled
            }])
                }, _toDisplayString(props.value.enabled ? _ctx.$t('labels.yes') : _ctx.$t('labels.no')), 3)
              ]),
              actions: _withCtx((props) => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    (_ctx.hasPermission('read'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: $event => (_ctx.view(props.value.id)),
                          class: "btn btn-xs btn-success",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0",
                          title: _ctx.$t('labels.buttons.view')
                        }, _hoisted_31, 8, _hoisted_29))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('edit'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: $event => (_ctx.edit(props.value.id)),
                          class: "btn btn-xs btn-warning",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0",
                          title: _ctx.$t('labels.buttons.edit')
                        }, _hoisted_34, 8, _hoisted_32))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('delete'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          onClick: $event => (_ctx.excluir(props.value.id)),
                          class: "btn btn-xs btn-danger",
                          "data-delay": "500",
                          "data-hasqtip": "1",
                          title: _ctx.$t('labels.buttons.remove')
                        }, _hoisted_37, 8, _hoisted_35))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "rows", "total", "sortable", "messages", "onDoSearch"])
          ])
        ])
      ])
    ])
  ], 64))
}